import { Link, useHistory } from "#src/components/Router.tsx";
import Container from "#src/components/layout/Container.tsx";
import { FilterUsersModal } from "#src/components/modals/FilterUsersModal.tsx";
import { OrganizationsModal } from "#src/components/modals/OrganizationsModal.tsx";
import { useStore } from "#src/stores/Store.tsx";
import { useUI } from "#src/stores/UI.tsx";
import { modals } from "#src/utils/modals.ts";
import tw from "#src/utils/tw.ts";
import { Level } from "#types/code-generator.ts";
import { capitalize } from "es-toolkit/compat";

interface Props {}

export function SuperAdminBar(_props: Props) {
  const store = useStore();

  function showOrganizations() {
    modals.show(OrganizationsModal);
  }

  const stage = process.env.NEXT_PUBLIC_STAGE;

  let stageLabel = (
    <>
      <strong>{capitalize(process.env.NEXT_PUBLIC_STAGE)} • Super Admin</strong>{" "}
      <i aria-hidden className="far fa-circle-arrow-right" />
    </>
  );

  if (process.env.NEXT_PUBLIC_STAGE === "prod") {
    stageLabel = (
      <>
        <strong>Production • Super Admin</strong>{" "}
        <i aria-hidden className="far fa-circle-arrow-right" />
      </>
    );
  } else if (store.isDemo) {
    stageLabel = (
      <>
        <strong>Demo</strong>
      </>
    );
  }

  let content = (
    <>
      <div className="flex items-center gap-4">
        <div className="flex-1">
          <button
            className="flex w-full items-center gap-1.5 truncate"
            onClick={showOrganizations}
          >
            <strong>
              {store.organization && store.organization.title}{" "}
              {store.isDemo && store.organization.title !== "Demo" && " (Demo)"}
            </strong>
            <i aria-hidden className="far fa-arrows-cross mt-1" />
          </button>
        </div>
        {store.user && store.user.isSalesOrAbove && (
          <a
            href={`${process.env.NEXT_PUBLIC_APP_SUPER_ADMIN}/super-admin`}
            className="inline-block flex-1 truncate text-right text-white"
            type="button"
          >
            {stageLabel}
          </a>
        )}
      </div>
    </>
  );

  return (
    <div
      className={tw(
        "z-40 h-[30px] pt-1 text-sm text-white shadow-xs print:hidden",
        store.isDemo
          ? "bg-dark"
          : stage === "dev"
            ? "bg-main"
            : "bg-organization"
      )}
    >
      <Container full>{content}</Container>
    </div>
  );
}

export function SuperAdminHeader(_props: Props) {
  const ui = useUI();
  const history = useHistory();

  function toggleMenu() {
    ui.toggleMenu();
  }

  function selectUser(userProfile) {
    if (userProfile) {
      history.push(`/super-admin/users/${userProfile.id}`);
    }
  }

  function searchForUsers() {
    modals.show(FilterUsersModal, {
      levels: [Level.Captyn],
      handleOk: (user) => {
        selectUser(user);
      },
    });
  }

  return (
    <>
      <div className="fixed top-0 left-0 z-40 w-full">
        <SuperAdminBar />
      </div>
      <div className="bg-dark fixed top-0 left-0 z-20 h-[80px] w-full shadow">
        <Container full className="h-[50px]">
          <div className="flex h-full items-center pt-[55px]">
            <div className="flex flex-1 items-center gap-2">
              <button
                className="text-main -mt-1 w-7 text-left text-2xl"
                onClick={toggleMenu}
              >
                {ui.menuOpen ? (
                  <i aria-hidden className="far fa-xmark" />
                ) : (
                  <i aria-hidden className="far fa-bars" />
                )}
              </button>
              <Link to="/super-admin" className="flex gap-2">
                <img
                  src="/img/captyn-logo-white.svg"
                  alt="Captyn"
                  width="91"
                  height="16"
                />
                <div className="bg-success rounded-sm px-2 pt-0.5 pb-1 text-xs font-bold text-white uppercase">
                  Super
                </div>
              </Link>
            </div>

            <button
              onClick={searchForUsers}
              className="text-organization h-9 w-9 rounded-full bg-white"
            >
              <i aria-hidden className="far fa-magnifying-glass" />
            </button>

            {/* {counts?.organizationsPending > 0 && (
              <>
                <Link
                  to={`/super-admin/organizations?status=Pending`}
                  className="ml-2 flex h-9 w-9 items-center justify-center rounded-full bg-organization text-white"
                >
                  {counts.organizationsPending}
                </Link>
              </>
            )} */}
          </div>
        </Container>
      </div>
    </>
  );
}
